import { buildWebPath } from "lib/resource-finder";

// This link will redirect EOR users to a Clockface account settings page, but non-EOR users to the well-known Clockwork account settings page.
export const ACCOUNT_SETTINGS_LINK = buildWebPath("/account_settings");
